import React from 'react';
import './header.css';
import headerimg from '../../assets/grabient-_gqngGRgkWgpxgE2.png' 

const Header = () => {

  return (
    <header className="header-section">
      <div className="header-banner">
          <img src={headerimg} alt="AI/XR/ROBOTICS SUSTAINABILITY BANNER" />
          {/* scattered star-like networks (small, bright) */}
    

          <div className="header-overlay">
            <div className="header-text bottom">
              <h2>Where Impact Meets Technology</h2>
              <p>AI · XR · Sustainability · Future Cities</p>
            </div>
          </div>
        </div>

    </header>
  )
}

export default Header
